import { TableViewStore, BaseListViewStore } from "core/stores";
import { FacilityInventoryCalculationItemService, FacilityInventoryCalculationService, FacilityOrderService, InventoryCalculationCutbackService } from "application/facility-order/services";
import { ProductService } from 'application/product/services';
import _ from 'lodash';
import { toDate, uuid } from "core/utils";
import { action, observable } from 'mobx';
import { resolveColumns } from '../../facility/util/resolveColumns';
import React from "react";
import { NumericInput } from "core/components";

class FacilityInventoryCalculationItemListViewStore extends BaseListViewStore {
	@observable accessor isDone = false;
	constructor(rootStore) {
        const facilityInventoryCalculationItemService = new FacilityInventoryCalculationItemService(rootStore.application.baasic.apiClient);
        const facilityInventoryCalculationService = new FacilityInventoryCalculationService(rootStore.application.baasic.apiClient);
        const facilityOrderId = rootStore.routerStore.routerState.params.facilityOrderId;
        const productService = new ProductService(rootStore.application.baasic.apiClient);
        super(rootStore, {
			autoInit: true,
			name: 'facility-inventory-calculation-items',
			routes: {
				details: (item, isCutback) => {
					this.rootStore.routerStore.goTo(
						'master.app.main.facility-order.inventory-calculation-cutback.edit',
						{ facilityOrderId: facilityOrderId, id: item.id, isCutback: isCutback }
					);
				},
			},
			actions: () => {
				return {
					find: async params => {
						const facilityInventoryCalculationResponse = await facilityInventoryCalculationService.getExisting(facilityOrderId);
						var facilityInventoryCalculationId;
						var isDone;
						if (facilityInventoryCalculationResponse === null) {
							var userId = rootStore.userStore.user.id;

							const response = await facilityInventoryCalculationService.create({
								createdByUserId: userId,
								facilityOrderId: facilityOrderId
							});
							
							if(response.data && response.data.isAutoSupplyEnfitAdapter){
								this.showAutoSupplyEnfitAdapterNotification();
							}
							
							facilityInventoryCalculationId = response.data.id;
							isDone = false;
						}
						else {
							facilityInventoryCalculationId = facilityInventoryCalculationResponse.id;
							isDone = facilityInventoryCalculationResponse.isDone;
						}
						const response = await facilityInventoryCalculationItemService.find(_.extend(params, {
							sort: 'Quantity|desc',
							embed: 'Product,InventoryCalculationCutbacks',
							facilityInventoryCalculationId: facilityInventoryCalculationId
						}));

						var caseResponse = null;
						if (response.data.item.length > 0) {
							var caseProducts = response.data.item.map(e => e.product && e.product.itemId.toLowerCase().replace("-n", "-cs-n").replace("-b", "-cs-b"));
							if (caseProducts.filter(p => p.indexOf("-cs") > -1).length > 0) {
								caseResponse = (await productService.find({ itemIds: caseProducts.filter(p => p.indexOf("-cs") > -1).join(','), isActive: true, rpp:1000 })).data.item;
							}
						}

						const responseData = _.extend(response.data, {
							item: _.map(response.data.item, (item => {
								var adjustedQtyArray = [];
								_.forEach(item.inventoryCalculationCutbacks, function (item) {
									adjustedQtyArray.push(parseInt(item.adjustedQty));
								})
								var adjustedQuantitySum = _.sum(adjustedQtyArray);
								var product = caseResponse && item.product && caseResponse.find(x => x.itemId.toLowerCase().replace("-cs-n", "-n").replace("-cs-b", "-b") === item.product.itemId.toLowerCase());
								// CalculatedQuantity ActualCutbackExtraSuppliesQuantity
								let obj = _.extend(
									item, {
									itemId: item.product && item.product.itemId,
									product: item.product && item.product.description,
									qtyPerCase: product && product.qtyPerCase ? product.qtyPerCase : 0,
									quantity: item.quantity,
									salesOrderQty: item.salesOrderQty,
									inventoryCountQty: item.inventoryCountQty,
									isExtra: item.calculatedQuantity < 0,
									calculatedQty: Math.abs(item.calculatedQuantity),
									isDone: isDone,
									isTypeCellBlank: item.calculatedQuantity === 0,
									totalCutbackQty: item.calculatedQuantity > 0 ? adjustedQuantitySum : '',
									stockNeededQuantity: item.salesOrderQty + item.quantity,
									totalCaseAndEachQty: ""
								}
								);
								this.calculateTotalCaseAndEachQty(obj);
								return obj;
							}))
						});
						this.facilityInventoryCalculationId = facilityInventoryCalculationId;
						this.isDone = isDone;
						return responseData;
					}
				};
			},
		});

        this.setTableStore(
			new TableViewStore(this.queryUtility, {
				columns: resolveColumns([
					{
						key: 'itemId',
						title: "FACILITY_INVENTORY_CALCULATION_ITEMS.LIST.COLUMNS.ITEM_ID",
						cell: (item) => {
							const isExtra = item.dataItem.isExtra;
							return (
								<td>
									{
										isExtra ? (
											<div className="type--left" key={uuid()}>
												{item.dataItem.itemId}
											</div>
										) :
											(
												<div className="type--left" key={uuid()}>
													{item.dataItem.itemId}
												</div>
											)
									}
								</td>
							)
						}
					},
					{
						key: 'product',
						title: "FACILITY_INVENTORY_CALCULATION_ITEMS.LIST.COLUMNS.PRODUCT",
						cell: (item) => {
							const isExtra = item.dataItem.isExtra;
							return (
								<td>
									{isExtra ? (
										<div className="type--left" key={uuid()}>
											{item.dataItem.product}
										</div>
									) :
										(
											<div className="type--left" key={uuid()}>
												{item.dataItem.product}
											</div>
										)
									}
								</td>
							)
						}
					},
					{
						key: 'inventoryCountQty',
						title: "FACILITY_INVENTORY_CALCULATION_ITEMS.LIST.COLUMNS.INVENTORY_COUNT_QTY",
						width: 183
					},
					{
						key: 'salesOrderQty',
						title: "FACILITY_INVENTORY_CALCULATION_ITEMS.LIST.COLUMNS.SALES_ORDER_QTY",
						width: 157
					},
					{
						key: 'quantity',
						title: "FACILITY_INVENTORY_CALCULATION_ITEMS.LIST.COLUMNS.EMERGENCY_STOCK",
						width: 133
					},
					{
						key: 'stockNeededQuantity',
						title: "FACILITY_INVENTORY_CALCULATION_ITEMS.LIST.COLUMNS.STOCK_NEEDED_QTY",
						width: 170
					},
					{
						key: 'isExtra',
						title: "FACILITY_INVENTORY_CALCULATION_ITEMS.LIST.COLUMNS.TYPE",
						cell: (item) => {
							const isExtra = item.dataItem.isExtra;
							const isTypeCellBlank = item.dataItem.isTypeCellBlank;

							return (
								<td>
									{
										isTypeCellBlank ?
											(
												<div className="type--left" key={uuid()}>
													{''}
												</div>
											) :
											isExtra ? (
												<div className="type--left" key={uuid()}>
													Extra Supplies
												</div>
											) :
												(
													<div className="type--left" key={uuid()}>
														Cutback
													</div>
												)
									}
								</td>
							)
						},
						width: 116
					},
					{
						key: 'calculatedQty',
						title: "FACILITY_INVENTORY_CALCULATION_ITEMS.LIST.COLUMNS.CALCULATED_QUANTITY",
						width: 149
					},
					{
						key: 'totalCutbackQty',
						title: "FACILITY_INVENTORY_CALCULATION_ITEMS.LIST.COLUMNS.TOTAL_CUTBACK_QUANTITY",
						cell: (item) => {
							const isDone = item.dataItem.isDone;
							const isExtra = item.dataItem.isExtra;
							const isTypeCellBlank = item.dataItem.isTypeCellBlank;
							return (
								<React.Fragment>
									{isTypeCellBlank ?
										<td>
											<div className="type--left" key={uuid()}>
												{item.dataItem.totalCutbackQty}
											</div>
										</td> :
										isExtra ?
											isDone ?
												<td>
													<div className="type--left" key={uuid()}>
														{item.dataItem.actualCutbackExtraSuppliesQuantity}
													</div>
												</td>
												:
												<td>
													<div className="type--left" key={uuid()}>
														<NumericInput style={{ padding: "0px" }}
															showLabel={false}
															onBlur={async (e) => {
																await this.saveQuantity(item.dataItem, e.target.value);
															}}
															defaultValue={item.dataItem.actualCutbackExtraSuppliesQuantity}
														/>
													</div>
												</td>
											:
											isDone ?
												<td>
													<div className="type--left" key={uuid()}>
														{item.dataItem.totalCutbackQty}
													</div>
												</td>
												:
												<td>
													<div className="type--left" key={uuid()}>
														<NumericInput style={{ padding: "0px" }}
															showLabel={false}
															onBlur={async (e) => {
																await this.updateCutbackAdjustedQty(item.dataItem, e.target.value);
															}}
															defaultValue={item.dataItem.totalCutbackQty}
														/>
													</div>
												</td>
									}
								</React.Fragment >
							)
						},
						width: 169
					},
					{
						key: 'totalCaseAndEachQty',
						title: "FACILITY_INVENTORY_CALCULATION_ITEMS.LIST.COLUMNS.TOTAL_CASE_AND_EACH_QUANTITY",
						width: 183
					},
				]),
				actions: {
					onPreview: (item) => this.routes.details(item, true),
					onPreviewExtraOrBlank: (item) => this.routes.details(item, false),
					onDelete: (item) => this.deleteResource(item)
				},
			})
		);
        this.setTitle();
    }

	async saveQuantity(item, value) {
		try {
			const facilityInventoryCalculationItemService = new FacilityInventoryCalculationItemService(this.rootStore.application.baasic.apiClient);
			await facilityInventoryCalculationItemService.updateActualCutbackExtraSuppliesQuantity({ id: item.id, actualQuantity: parseInt(value) });

			item.actualCutbackExtraSuppliesQuantity = value;
			this.calculateTotalCaseAndEachQty(item);

			this.rootStore.notificationStore.success("Actual CB/ES Quantity successfully updated.");
		} catch (err) {
			this.rootStore.notificationStore.error("Error occurred while trying to change Actual CB/ES Quantity.");
		}
	}

	calculateTotalCaseAndEachQty(item) {
		let qty = item.calculatedQuantity < 0 ? item.salesOrderQty + item.actualCutbackExtraSuppliesQuantity : item.calculatedQuantity > 0 ? item.salesOrderQty - item.totalCutbackQty : 0;
		
		if(qty == 0)
			item.totalCaseAndEachQty = " ";
		else{
			item.totalCaseAndEachQty = item.qtyPerCase == 0 ? `0 Case(s), ${qty} Each(es)` : `${Math.floor(qty / item.qtyPerCase)} Case(s), ${qty % item.qtyPerCase} Each(es)`;
		}
	}

	async updateCutbackAdjustedQty(item, value) {
		try {
			const inventoryCalculationCutbackService = new InventoryCalculationCutbackService(this.rootStore.application.baasic.apiClient);
			await inventoryCalculationCutbackService.updateCutbackAdjustedQty({ calculationItemId: item.id, adjustedQty: value });
			
			item.totalCutbackQty = value;
			this.calculateTotalCaseAndEachQty(item);

			this.rootStore.notificationStore.success("Actual CB/ES Quantity successfully updated.");
		} catch (err) {
			this.queryUtility.fetch();
			this.rootStore.notificationStore.error(err && err.data && err.data.errors ? err.data.errors : "Error occurred while trying to change Actual CB/ES Quantity.");
		}
	}

	async setTitle() {
		const facilityOrderService = new FacilityOrderService(
			this.rootStore.application.baasic.apiClient
		);
		const facilityOrderId =
			this.rootStore.routerStore.routerState.params.facilityOrderId;
		const facilityOrderResponse = await facilityOrderService.get(
			facilityOrderId,
			{ embed: "Facility" }
		);
		const facilityName =
			facilityOrderResponse.data.facility &&
			facilityOrderResponse.data.facility.name;
		const facilityOrderTemplateTitle = `Inventory calculation - ${facilityName} - DOS [${toDate(
			facilityOrderResponse.data.dateOfService
		)}]`;

		this.rootStore.titleStore.setTitle(facilityName ? `IC - ${facilityName}` : 'Inventory calculation');

		this.rootStore.viewStore.setNavigationOptions({
			title: facilityOrderTemplateTitle,
			hideColon: true,
			onPreview: this.goToFacility,
			onEdit: this.editFacility,
			onCalendar: this.goToCalendar
		});
	}

	@action.bound
	async refresh() {
		const { modalStore, notificationStore } = this.rootStore;
		const facilityInventoryCalculationService = new FacilityInventoryCalculationService(this.rootStore.application.baasic.apiClient);
		modalStore.showConfirm(
			'LIST_LAYOUT.CONFIRM_REFRESH',
			async () => {
				try {
					var response = await facilityInventoryCalculationService.refresh(this.facilityInventoryCalculationId);
					if(response && response.customValues && response.customValues.isAutoSupplyEnfitAdapter){
						this.showAutoSupplyEnfitAdapterNotification();
					}
					notificationStore.success('LIST_LAYOUT.SUCCESS_REFRESH');
					await this.queryUtility.fetch();
				} catch (err) {
					notificationStore.error('LIST_LAYOUT.ERROR_REFRESH', err);
				}
			}
		);
		return true;
	}

	@action.bound
	async editInventory() {
		try {
			const facilityOrderService = new FacilityOrderService(
				this.rootStore.application.baasic.apiClient
			);
			const facilityOrderId = this.rootStore.routerStore.routerState.params.facilityOrderId;
			const facilityOrderResponse = await facilityOrderService.get(
				facilityOrderId,
			);
			let facilityInventoryCountHeaderId = facilityOrderResponse.data.facilityInventoryCountHeaderId;
			let url = this.rootStore.routerStore.findRoute('master.app.main.facility-inventory.facility-inventory-detail.list').pattern;
			url = url.replace(":facilityInventoryCountHeaderId", facilityInventoryCountHeaderId);
			window.open(`${url}`);
		}
		catch (err) {
			if (err.data && err.data.errors) {
				this.rootStore.notificationStore.error(err.data.errors);
			}
			else {
				this.rootStore.notificationStore.error("Error occurred while trying to edit a inventory.");
			}
		}
	}

	@action.bound
	async process() {
		const { modalStore, notificationStore } = this.rootStore;
		const facilityInventoryCalculationService = new FacilityInventoryCalculationService(this.rootStore.application.baasic.apiClient);
		modalStore.showConfirm(
			'LIST_LAYOUT.CONFIRM_PROCESS',
			async () => {
				try {
					await facilityInventoryCalculationService.process(this.facilityInventoryCalculationId);
					notificationStore.success('LIST_LAYOUT.SUCCESS_PROCESS');
					await this.queryUtility.fetch();
				} catch (err) {
					notificationStore.error('LIST_LAYOUT.ERROR_PROCESS', err);
				}
			}
		);
		return true;
	}

	@action.bound
	async deleteResource(item) {
		const { modalStore, notificationStore } = this.rootStore;
		const facilityInventoryCalculationItemService = new FacilityInventoryCalculationItemService(this.rootStore.application.baasic.apiClient);

		modalStore.showConfirm(
			'FACILITY_INVENTORY_CALCULATION_ITEMS.LIST.DELETE.PRODUCT',
			async () => {
				try {
					await facilityInventoryCalculationItemService.delete(item);
					notificationStore.success('FACILITY_INVENTORY_CALCULATION_ITEMS.LIST.DELETE.PRODUCT_SUCCESS');
					await this.queryUtility.fetch();
				} catch (err) {
					notificationStore.error('FACILITY_INVENTORY_CALCULATION_ITEMS.LIST.DELETE.PRODUCT_ERROR', err);
				}
			}
		);
	}

	@action.bound
	showAutoSupplyEnfitAdapterNotification() {
        this.rootStore.notificationStore.success('FACILITY_ORDER_NEW_FLOW_INVENTORY.PREVIEW.AUTO_SUPPLY_ENFIT_ADAPTER');
    }
}

export default FacilityInventoryCalculationItemListViewStore;

